/**
 * @description Displays the personnel mapping name field
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';

const NameField = ({ mappingNames }) => {
  const { control } = useFormContext();

  // Validates that the mapping name provided is unique
  function isUniqueName (value) {
    const compareValue = value.trim();

    return mappingNames.includes(compareValue.toLowerCase()) ? `Mapping name must be unique. "${ compareValue }" already exists.` : null;
  }

  return (
    <Controller
      control={control}
      name='name'
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TextField
          error={Boolean(error)}
          label='Mapping Name'
          onChange={(evt) => onChange(evt.target.value)}
          helperText={error ? error.message : ''}
          required
          value={value ?? ''}
          variant='outlined'
        />
      )}
      rules={{
        required: 'Mapping name is required',
        validate: isUniqueName
      }}
    />
  )
};

NameField.propTypes = {
  mappingNames: PropTypes.arrayOf(PropTypes.string)
};

NameField.defaultProps = {
  mappingNames: []
};

export default NameField;
